import React, { ReactElement, FunctionComponent, memo } from 'react'
import Text from '@sport1/react-elements/Text'
import Touchable from '@sport1/react-elements/Touchable'
import withTheme from '@sport1/react-elements/withTheme'
import { FontSizes, LineHeights, TextAlignTypes, TextColorTypes } from '../FontTypes'
import ThemeInterface from '../../../themes/ThemeInterface'
import lightTheme from '../../../themes/LightTheme'
import { TestID } from '../../../utils/PropTypesDefinitions'
import LinkProps from '../../../Link/LinkProps'

export type WebHeadlineType = {
    /** the tag which should be rendered on web, e.g. h1 (normally it's a span) */
    webHeadlineType?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
}

export type BasicTextProps = WebHeadlineType & {
    children: string | ReactElement
    color?: TextColorTypes
    underline?: boolean
    uppercase?: boolean
    textAlign?: TextAlignTypes
    fontSize: FontSizes | FontSizes[]
    lineHeight: LineHeights | LineHeights[]
    bold?: boolean
    numberOfLines?: number
    theme?: ThemeInterface
    onPress?: () => void
    href?: string
    allowFontScaling?: false
    className?: string
    paddingLeft?: number | number[] | string | string[]
    paddingRight?: number | number[] | string | string[]
    paddingTop?: number | number[] | string | string[]
    paddingBottom?: number | number[] | string | string[]
    paddingX?: number | number[] | string | string[]
    paddingY?: number | number[] | string | string[]
} & LinkProps &
    TestID

const BasicText: FunctionComponent<BasicTextProps> = ({
    children,
    color = 'onyx',
    className,
    underline,
    uppercase,
    textAlign = 'left',
    fontSize,
    lineHeight,
    numberOfLines,
    bold,
    theme = lightTheme,
    onPress,
    href,
    testID,
    allowFontScaling,
    webHeadlineType,
    paddingTop,
    paddingBottom,
    paddingLeft,
    paddingRight,
    paddingX,
    paddingY,
    webRel,
}): ReactElement => {
    const text = (
        <Text
            paddingTop={paddingTop}
            paddingBottom={paddingBottom}
            paddingLeft={paddingLeft}
            paddingRight={paddingRight}
            paddingX={paddingX}
            paddingY={paddingY}
            color={color}
            className={className}
            textDecorationLine={underline ? 'underline' : undefined}
            fontFamily={bold ? theme && theme.fontFamilyBold : theme && theme.fontFamily}
            {...{
                fontSize,
                lineHeight,
                textAlign,
                uppercase,
                numberOfLines,
                testID,
                allowFontScaling,
                webHeadlineType,
            }}
        >
            {children}
        </Text>
    )
    return onPress || href ? (
        <Touchable onPress={onPress} href={href} webRel={webRel}>
            {text}
        </Touchable>
    ) : (
        text
    )
}

export default memo(withTheme(BasicText)) as FunctionComponent<BasicTextProps>
